import React from "react";

const Loader = ({ isLoading, message = "Processing..." }) => {
  if (!isLoading) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(3, 7, 18, 0.9)", // Darker, premium feel
        backdropFilter: "blur(12px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: "20px", // Mobile safety margin
      }}
    >
      <style>{`
        @keyframes spinClockwise {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        @keyframes spinCounter {
          from { transform: rotate(360deg); }
          to { transform: rotate(0deg); }
        }

        @keyframes pulseLogo {
          0%, 100% { transform: scale(1); filter: drop-shadow(0 0 5px rgba(99, 102, 241, 0.4)); }
          50% { transform: scale(0.95); filter: drop-shadow(0 0 20px rgba(99, 102, 241, 0.8)); }
        }

        /* Responsive Container */
        .loader-main-box {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          /* Mobile standard: 140px, Desktop: 180px */
          width: clamp(140px, 20vw, 180px);
          height: clamp(140px, 20vw, 180px);
        }

        .ring {
          position: absolute;
          border-radius: 50%;
          border: 3px solid transparent;
        }

        .outer-ring {
          width: 100%;
          height: 100%;
          border-top-color: #6366f1;
          border-bottom-color: #6366f1;
          animation: spinClockwise 2.5s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite;
        }

        .inner-ring {
          width: 75%;
          height: 75%;
          border-left-color: #22c55e;
          border-right-color: #22c55e;
          animation: spinCounter 1.5s linear infinite;
        }

        .logo-center {
          position: absolute;
          width: 45%;
          height: 45%;
          background: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          animation: pulseLogo 2s ease-in-out infinite;
          overflow: hidden;
          padding: 6px;
        }
      `}</style>

      <div className="loader-main-box">
        {/* Animated Rings */}
        <div className="ring outer-ring" />
        <div className="ring inner-ring" />
        
        {/* Fixed Center Logo */}
        <div className="logo-center">
          <img
            src="/mtlogo.jpg"
            alt="MT"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "50%"
            }}
          />
        </div>
      </div>

      {/* Text Section - Fully Responsive */}
      <div style={{ marginTop: "2rem", textAlign: "center", maxWidth: "80%" }}>
        <h3 style={{ 
          color: "#f8fafc", 
          fontSize: "clamp(1.1rem, 4vw, 1.5rem)", 
          fontWeight: "700", 
          margin: 0,
          letterSpacing: "1px"
        }}>
          {message}
        </h3>
        <div style={{ 
          marginTop: "10px", 
          display: "flex", 
          justifyContent: "center", 
          gap: "5px" 
        }}>
          {/* Subtle loading dots */}
          <span style={{ width: "6px", height: "6px", background: "#6366f1", borderRadius: "50%", opacity: 0.6 }}></span>
          <span style={{ width: "6px", height: "6px", background: "#22c55e", borderRadius: "50%", opacity: 0.8 }}></span>
          <span style={{ width: "6px", height: "6px", background: "#6366f1", borderRadius: "50%", opacity: 0.6 }}></span>
        </div>
      </div>
    </div>
  );
};

export default Loader;